export const VECTOR_FIELD_PREFIX = 'vector:';
export const EMBEDDING_CHUNK_SIZE = 512;
export const EMBEDDING_CHUNK_OVERLAP = 8;
export const DEFAULT_VECTOR_MINIMUM_SCORE = 0.5;

export function toVectorSelectValue(fieldKey: string) {
	return `${VECTOR_FIELD_PREFIX}${fieldKey}`;
}

export function parseSearchFieldSelectValue(value: string): { field: string; isVector: boolean } {
	if (value.startsWith(VECTOR_FIELD_PREFIX)) {
		return { field: value.slice(VECTOR_FIELD_PREFIX.length), isVector: true };
	}
	return { field: value, isVector: false };
}

export function searchFieldSelectValue(filter: { field: string; vectorMinimumScore?: number }) {
	return typeof filter.vectorMinimumScore === 'number' ? toVectorSelectValue(filter.field) : filter.field;
}

export function isVectorSearch(filter: { vectorMinimumScore?: number }) {
	return typeof filter.vectorMinimumScore === 'number';
}
